import { App, Button, Card, Col, Flex, Form, Input, Row, Space } from "antd";
import { FormProvider } from "antd/es/form/context";
import TextArea from "antd/es/input/TextArea";
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { ResearcherInterface } from "../../model/IResearcher";
import CkEditor from "../../ckeditor/ckEditor";
import { Editor } from '@ckeditor/ckeditor5-core'; // Import Editor type
import { useNavigate } from "react-router-dom";

export function VolunteerInform(){

    const { message,notification } = App.useApp();
    const navigate = useNavigate();

    const [form] = Form.useForm();
    const [HeadResData,setHeadResdata] = useState<ResearcherInterface>();
    const [researcher_position, setresearcher_position] = useState('ยังไม่กรอก');

    const ParticipantAmountRef = useRef<Editor | null>(null);
    const ParticipantGroupByRef = useRef<Editor | null>(null);
    const ParticipantProcedureRef = useRef<Editor | null>(null);
    const [ParticipantAmount,setParticipantAmount] = useState('')
    const [ParticipantGroupBy,setParticipantGroupBy] = useState('')
    const [ParticipantProcedure,setParticipantProcedure] = useState('')
    const { CKEditors, getHTML } = CkEditor();

    const handleAmountEditorChange = () =>{
        setParticipantAmount(getHTML(ParticipantAmountRef))
    }
    const handleGroupByEditorChange = () =>{
        setParticipantGroupBy(getHTML(ParticipantGroupByRef))
    }
    const handleProcedureEditorChange = () =>{
        setParticipantProcedure(getHTML(ParticipantProcedureRef))
    }

    useEffect(() => {
        const name = sessionStorage.getItem('fullname') || '';
        form.setFieldsValue({ researcher_THname: name });

        axios.get(`${process.env.REACT_APP_BASE}/getFullProjectInfo/${sessionStorage.getItem('Order_ID')}/${sessionStorage.getItem('user')}`).then(response=>{
            if(response.status=200){
                const tmpdata = response.data.data
                form.setFieldsValue(tmpdata)
                setHeadResdata(tmpdata)
                setresearcher_position(tmpdata.posname)
                setParticipantAmount(tmpdata.ParticipantAmount)
                setParticipantGroupBy(tmpdata.ParticipantGroupBy)
                setParticipantProcedure(tmpdata.ParticipantProcedure)
                
                if(sessionStorage.getItem('status')=='Outsider')
                    { 
                        axios.get(`${process.env.REACT_APP_BASE}/getOutsiderdata/${sessionStorage.getItem('user')}`).then(res=>{
                        if(response.status==200){
                          console.log(res.data[0])
                          if(res.data[0].home_address!=null
                            &&res.data[0].wp_address!=null
                            &&res.data[0].wp_tel!=null
                            &&res.data[0].home_tel!=null){
                            form.setFieldsValue({
                                researcher_address:res.data[0].home_address,
                                researcher_wp:res.data[0].wp_address,
                                researcher_wptel:res.data[0].wp_tel,
                                researcher_tel:res.data[0].home_tel,
                            })
                          }
                           
                        }
                    })}
            }
            
        })
 }, []);

        

    async function SaveEdit(){
        const FormData = form.getFieldsValue();

        console.log(FormData)
        const data = {
            part:'part2',
            researcher_address:FormData.researcher_address,
            researcher_wp:FormData.researcher_wp,
            researcher_wptel:FormData.researcher_wptel,
            researcher_tel:FormData.researcher_tel,
            researcher_phone:FormData.researcher_phone,
            researcher_email:FormData.researcher_email,

            relevantTopic:FormData.relevantTopic,
            Objective:FormData.Objective,

            ParticipantCharacteristicAndCriterion:FormData.ParticipantCharacteristicAndCriterion,
            ParticipantAmount:getHTML(ParticipantAmountRef),
            ParticipantRecruit:FormData.ParticipantRecruit,
            ParticipantReason:FormData.ParticipantReason,
            ParticipantGroupBy:getHTML(ParticipantGroupByRef),
            ParticipantProcedure:getHTML(ParticipantProcedureRef),
            ParticipantAcknowledgementMethod:FormData.ParticipantAcknowledgementMethod,
            MedicalRecordInfoAllowedByHead:FormData.MedicalRecordInfoAllowedByHead,
            MedicalRecordactionAllowedByHead:FormData.MedicalRecordactionAllowedByHead,
            RiskAndPrevent:FormData.RiskAndPrevent,
            Benefit:FormData.Benefit,
            Coverage:FormData.Coverage,
            
        }
        console.log(data)
        await axios.post(`${process.env.REACT_APP_BASE}/SaveEdit/${sessionStorage.getItem('Order_ID')}/${sessionStorage.getItem('user')}`,data).then(response=>{
            if(response.status==200){
                notification.success({
                    message: 'บันทึกสำเร็จ',
                    description: 'ข้อมูลของคุณถูกบันทึกเรียบร้อยแล้ว',
                  });
            }else{
                notification.error({
                    message: 'บันทึกไม่สำเร็จ',
                    description: 'กรุณาตรวจสอบข้อมูลของท่าน',
                  });
            }}
        )
    }

    async function SaveBack(){
        const FormData = form.getFieldsValue();
        const data = {
            part:'part2',
            researcher_address:FormData.researcher_address,
            researcher_wp:FormData.researcher_wp,
            researcher_wptel:FormData.researcher_wptel,
            researcher_tel:FormData.researcher_tel,
            researcher_phone:FormData.researcher_phone,
            researcher_email:FormData.researcher_email,

            relevantTopic:FormData.relevantTopic,
            Objective:FormData.Objective,

            ParticipantCharacteristicAndCriterion:FormData.ParticipantCharacteristicAndCriterion,
            ParticipantAmount:getHTML(ParticipantAmountRef),
            ParticipantRecruit:FormData.ParticipantRecruit,
            ParticipantReason:FormData.ParticipantReason,
            ParticipantGroupBy:getHTML(ParticipantGroupByRef),

            ParticipantProcedure:getHTML(ParticipantProcedureRef),
            ParticipantAcknowledgementMethod:FormData.ParticipantAcknowledgementMethod,
            MedicalRecordInfoAllowedByHead:FormData.MedicalRecordInfoAllowedByHead,
            MedicalRecordactionAllowedByHead:FormData.MedicalRecordactionAllowedByHead,
            RiskAndPrevent:FormData.RiskAndPrevent,
            Benefit:FormData.Benefit,
            Coverage:FormData.Coverage,
            
        }
        console.log(data)
        await axios.post(`${process.env.REACT_APP_BASE}/SaveEdit/${sessionStorage.getItem('Order_ID')}/${sessionStorage.getItem('user')}`,data).then(response=>{
            if(response.status==200){
                notification.success({
                    message: 'บันทึกสำเร็จ',
                    description: 'ข้อมูลของคุณถูกบันทึกเรียบร้อยแล้ว',
                  });
                  navigate(`/VU_HREC/UploadDoc`)
                  
            }else{
                notification.error({
                    message: 'บันทึกไม่สำเร็จ',
                    description: 'กรุณาตรวจสอบข้อมูลของท่าน',
                  });
            }}
        )
    }
    return(<>
        <h1 style={{fontSize:50,marginBottom:0}}>แบบฟอร์มการยื่นคำขอพิจารณาจริยธรรมวิจัยในมนุษย์</h1>
        <h1 style={{fontSize:40,marginTop:0,marginBottom:10}}>มว.จ.002 แบบเอกสารชี้แจงอาสาสมัครเพื่อประกอบการพิจารณาจริยธรรมการวิจัยในมนุษย์
        </h1>
        <hr/>
        <Form form={form}>
        <Card>
            <h3>คำแนะนำในการเขียน</h3>
            <p style={{marginLeft:'5vw'}}>1. ข้อมูลที่เกี่ยวข้องกับการให้คำยินยอมและเอกสารอื่น ๆ ภาษาที่ใช้ต้องเป็นภาษาที่เข้าใจง่าย หลีกเลี่ยงภาษาทางวิชาการ 
            ศัพท์ทางการแพทย์ ภาษาอังกฤษ หากจำเป็นต้องใช้ต้องมีคำอธิบายประกอบด้วย</p>
            <p style={{marginLeft:'5vw'}}>2. ให้ผู้วิจัยปรับแก้ไขรายละเอียดในส่วนที่เกี่ยวข้องกับงานวิจัยให้ครบถ้วน ทั้งนี้ หากข้อใดไม่เกี่ยวข้องกับงานวิจัยสามารถ
            ตัดข้อความออกได้ และเรียงลำดับหมายเลขหน้าข้อให้ถูกต้อง</p>
        </Card>
        <br/>
        <Card>
            <h3>ข้อมูลนักวิจัย</h3>
                <Row style={{marginLeft:'5vw'}}>
                    <Col span={12}>
                        <Flex><p>ชื่อผู้วิจัย : &nbsp;</p><p>{sessionStorage.getItem('fullname')}</p></Flex>
                    </Col>
                    <Col span={12}>
                    <Flex><p style={{marginLeft:'5vw'}}>ตำแหน่ง : &nbsp;</p><p>{researcher_position}</p></Flex>
                    </Col>
                </Row>
                <Form.Item style={{marginLeft:'5vw'}}  name='researcher_address' label='ที่อยู่บ้าน'>
                    <TextArea placeholder='กรุณากรอกที่อยู่ปัจจุบันของท่าน' 
                    style={{width:'50vw'}}  autoSize/>
                </Form.Item>
                <Form.Item style={{marginLeft:'5vw'}}  name='researcher_wp' label='ที่อยู่ที่ทำงาน'>
                    <TextArea placeholder='กรุณากรอกที่อยู่ที่ทำงานของท่าน' style={{width:'50vw'}}  autoSize/>
                </Form.Item>
                <Row style={{marginLeft:'5vw'}}>
                    <Col span={12}>
                        <div style={{ display: 'flex', alignItems: 'center'}}>
                            <Form.Item label='เบอร์โทร(ที่ทำงาน)' name='researcher_wptel'>
                                <Input placeholder='กรุณากรอกเบอร์โทรที่ทำงาน'/>
                            </Form.Item>
                        </div>
                    </Col>
                    <Col span={12}>
                        <div style={{ display: 'flex', alignItems: 'center', marginLeft: '5vw' }}>
                            <Form.Item label='โทรศัพท์บ้าน' name='researcher_tel'>
                                <Input placeholder='กรุณากรอกเบอร์โทรศัพท์บ้าน'/>
                            </Form.Item>
                        </div>
                    </Col>
                </Row>
                
                <Row style={{marginLeft:'5vw'}}>
                    <Col span={12}>
                        <div style={{ display: 'flex', alignItems: 'center'}}>
                            <Form.Item label='โทรศัพท์มือถือ' name='researcher_phone'>
                                <Input placeholder='กรุณากรอกเบอร์โทรศัพท์มือถือ'/>
                            </Form.Item>
                        </div>
                    </Col>
                    <Col span={12}>
                        <div style={{ display: 'flex', alignItems: 'center', marginLeft: '5vw' }}>
                            <Form.Item label='email' name='researcher_email'>
                                <Input placeholder='กรุณากรอกอีเมล'/>
                            </Form.Item>
                        </div>
                    </Col>
                </Row>
               
        </Card>
        <br/>
        <Card>
            <h2>ข้อมูลเกี่ยวกับโครงการ</h2>
            
            <Form.Item style={{ marginLeft: '5vw' }} name='relevantTopic' label='โครงการวิจัยนี้เกี่ยวข้องกับการวิจัย เรื่อง'>
                <Input placeholder="กรุณากรอกลิ้งค์ข้อมูลชื่อเรื่องมาจากการกรอกข้อมูลก่อนหน้า" />
            </Form.Item>
            <Form.Item style={{marginLeft:'5vw'}}  name='Objective' label='วัตถุประสงค์'>
                <TextArea placeholder="กรุณากรอกวัตถุประสงค์ของโครงการของท่าน"  style={{width:'50vw'}}  autoSize/>
            </Form.Item>
            <h3>รายละเอียดของกลุ่มประชากร/กลุ่มตัวอย่าง/ผู้มีส่วนร่วมในการวิจัย</h3>
            <p style={{marginLeft:'5vw'}}>ลักษณะของกลุ่มประชากร/กลุ่มตัวอย่าง/ผู้มีส่วนร่วมในการวิจัย  เกณฑ์การคัดเข้า และเกณฑ์การคัดออก</p>
            <Form.Item  style={{marginLeft:'10vw'}}  name={'ParticipantCharacteristicAndCriterion'}>
                <TextArea placeholder="กรุณากรอกลักษณะ เกณฑ์การคัดเข้า และเกณฑ์การคัดออกอย่างละเอียด"  autoSize/>
            </Form.Item>
            <p style={{marginLeft:'5vw'}}>จำนวนของกลุ่มประชากร/กลุ่มตัวอย่าง/ผู้มีส่วนร่วมในการวิจัย</p>
            <Form.Item  style={{marginLeft:'10vw'}} name={'ParticipantAmount'}>
                <CKEditors 
                    myRef={ParticipantAmountRef}
                    htmlBox={ParticipantAmount}
                    onBlur={handleAmountEditorChange}
                    placeholder='กรุณาจำนวนของกลุ่มประชากร/กลุ่มตัวอย่าง/ผู้มีส่วนร่วมในการวิจัย'
                    toolstate={true}/>
            </Form.Item>
            <p style={{marginLeft:'5vw'}}>วิธีการได้มาซึ่งกลุ่มประชากร/กลุ่มตัวอย่าง/ผู้มีส่วนร่วมในการวิจัย</p>
            <Form.Item  style={{marginLeft:'10vw'}} name={'ParticipantRecruit'}>
                <TextArea placeholder="กรุณาวิธีการได้มาซึ่งกลุ่มประชากร/กลุ่มตัวอย่าง/ผู้มีส่วนร่วมในการวิจัยอย่างละเอียด" autoSize/>
            </Form.Item>
            <p style={{marginLeft:'5vw'}}>เหตุผลที่ได้รับเชิญเข้าร่วมโครงการวิจัย</p>
            <Form.Item  style={{marginLeft:'10vw'}} name={'ParticipantReason'}>
                <TextArea  placeholder="กรุณาอธิบายเหตุผลที่ได้รับเชิญเข้าร่วมโครงการวิจัยอย่างละเอียด" autoSize/>
            </Form.Item>
           
            <br/>
            <hr style={{ border: "1px dashed #ccc" }} />
            <br/>

            <p>กระบวนการการวิจัยที่กระทำต่อกลุ่มประชากร/กลุ่มตัวอย่าง/ผู้มีส่วนร่วมในการวิจัย</p>
           
            <br/>
            <Form.Item  style={{marginLeft:'5vw'}} name={'ParticipantProcedure'}>
                <br/>
                <CKEditors 
                    myRef={ParticipantProcedureRef}
                    htmlBox={ParticipantProcedure}
                    onBlur={handleProcedureEditorChange}
                    placeholder={`*คำอธิบายวิธีการเขียนชี้แจงอาสาสมัคร : กระบวนการการวิจัยที่กระทำต่อกลุ่มประชากร/กลุ่มตัวอย่าง/ผู้มีส่วนร่วมในการวิจัย ใครเป็นผู้ดำเนินการ ทำอะไร อย่างไร เมื่อใด ที่ไหน ใช้เวลาเท่าไร ให้ตรงกับโครงการวิจัย หากเป็นการวิจัยที่กลุ่มประชากร/กลุ่มตัวอย่าง/ผู้มีส่วนร่วมในการวิจัยต้องเปิดเผยข้อมูลส่วนตัว หรือบันทึกความเห็น หรือการบันทึกภาพ หรือการนำส่วนประกอบของร่างกายไปศึกษา เช่น เลือด ปัสสาวะ ต้องมีการระบุให้ชัดเจน โดยเฉพาะปริมาณที่ใช้ เช่น มีการเจาะเลือด 2 ช้อนชา เป็นต้น\n\n**ต้องมีการระบุว่า เมื่อเสร็จสิ้นการวิจัยแล้วข้อมูลที่เกี่ยวข้องกับผู้มีส่วนร่วมในการวิจัยจะถูกทำลาย เช่น จะทำลายข้อมูล แถบบันทึกเสียงงานวิจัย ภาพถ่าย จะทำลายเลือด เป็นต้น หรือหากจะเก็บไว้เพื่อศึกษาต่อก็ต้องระบุให้ชัดเจน`}
                    toolstate={true}/>
            </Form.Item>
            <p>กระบวนการให้ข้อมูลแก่กลุ่มประชากร หรือผู้มีส่วนร่วมในการวิจัย</p>
        
            <Form.Item  style={{marginLeft:'5vw'}} name='ParticipantAcknowledgementMethod'>
                <TextArea
                    placeholder={
                            `คำอธิบายวิธีการเขียนชี้แจงอาสาสมัคร : กระบวนการให้ข้อมูลแก่กลุ่มประชากร หรือผู้มีส่วนร่วมในการวิจัย ทำด้วยวิธีใด ใครเป็นผู้ดำเนินการ หากเป็นกลุ่มประชากร/กลุ่มตัวอย่าง/ผู้มีส่วนร่วมในการวิจัยที่อ่านไม่ออก เขียนไม่ได้ หรือไม่พูดภาษาไทย จะมีกระบวนการในการขอความยินยอมอย่างไร\n
**หากเป็นกลุ่มผู้ด้อยโอกาส หรือกลุ่มเปราะบาง เช่น หญิงตั้งครรภ์ ผู้สูงอายุ เด็กเล็ก ผู้ป่วยมะเร็ง ผู้พิการ ผู้ป่วยเด็ก ผู้ป่วยจิตเวช ผู้ป่วยสมองเสื่อม ผู้ต้องขัง ทหารเกณฑ์ อาชีพผิดกฎหมาย แรงงานต่างด้าวเข้าประเทศผิดกฎหมาย เป็นต้น ที่ไม่สามารถให้คำยินยอมด้วยตัวเองได้ ให้ระบุวิธีปฏิบัติในการขอความยินยอมด้วย`
                        }
                        autoSize
                        />
                </Form.Item>
            <hr style={{ border: "1px dashed #ccc" }} />
            <h2>การใช้เวชระเบียน</h2>
            <p style={{ marginTop: 0 }}>
                **หากไม่เกี่ยวข้องกับงานวิจัยให้ระบุว่า&nbsp;
                <span style={{ color: 'red' }}>งานวิจัยไม่เกี่ยวข้องกับเวชระเบียน</span>&nbsp;**
            </p>
            <p style={{marginLeft:'5vw'}}>การวิจัยที่ดูข้อมูลจากเวชระเบียนเท่านั้น ต้องได้รับการอนุมัติจากผู้มีอำนาจหน้าที่ เช่น ผู้อำนวยการโรงพยาบาล</p>
            <Form.Item  style={{marginLeft:'10vw'}} name={'MedicalRecordInfoAllowedByHead'}>
                <TextArea placeholder='**หากไม่เกี่ยวข้องกับงานวิจัยให้ระบุว่า งานวิจัยไม่เกี่ยวข้องกับเวชระเบียน **'  autoSize/>
            </Form.Item>
            <p style={{marginLeft:'5vw'}}>การวิจัยที่มีการกระทำต่อผู้ป่วยและใช้เวชระเบียนต้องได้รับการอนุมัติจากผู้มีอำนาจหน้าที่ เช่น ผู้อำนวยการโรงพยาบาลและการยินยอมจากผู้ป่วย</p>
            <Form.Item  style={{marginLeft:'10vw'}} name={'MedicalRecordactionAllowedByHead'}>
                <TextArea placeholder='**หากไม่เกี่ยวข้องกับงานวิจัยให้ระบุว่า งานวิจัยไม่เกี่ยวข้องกับเวชระเบียน **'  autoSize/>
            </Form.Item>
            <hr style={{ border: "1px dashed #ccc" }} />
            <p>ข้อมูลเกี่ยวกับอันตรายหรือความเสี่ยงที่อาจเกิดขึ้นแก่กลุ่มประชากร/กลุ่มตัวอย่าง/ผู้มีส่วนร่วมในการวิจัย รวมทั้งวิธีการป้องกัน/ปกป้องอันตราย และความเสี่ยงนั้น</p>
            <Form.Item  style={{marginLeft:'5vw'}} name='RiskAndPrevent'>
                <TextArea placeholder={`        *คำอธิบายวิธีการเขียนชี้แจงอาสาสมัคร : อธิบายข้อมูลเกี่ยวกับอันตรายหรือความเสี่ยงที่อาจเกิดขึ้นแก่กลุ่มประชากร/กลุ่มตัวอย่าง/ผู้มีส่วนร่วมในการวิจัย เช่น อาการหรืออาการแสดงที่อาจมีผลต่อร่างกาย จิตใจ สังคม เศรษฐกิจ ความเชื่อของผู้มีส่วนร่วมในการวิจัย รวมทั้งวิธีการป้องกัน/ปกป้องอันตราย และความเสี่ยงนั้น ฯลฯ หากเกิดภาวะดังกล่าว ให้ผู้วิจัยระบุแนวทางการช่วยเหลือหรือการรักษาอย่างไร`} autoSize/>
            </Form.Item>
            <p>ประโยชน์ในการเข้าร่วมวิจัย</p>
            <Form.Item  style={{marginLeft:'5vw'}} name={'Benefit'}>
                <TextArea placeholder={`        *คำอธิบายวิธีการเขียนชี้แจงอาสาสมัคร : ให้อธิบายประโยชน์ในการเข้าร่วมวิจัย ทั้งประโยชน์ส่วนบุคคล ส่วนรวม หรือเป็นประโยชน์ทางวิชาการ แต่อย่าระบุประโยชน์ที่ได้รับเกินความจริง หากผลการศึกษาเป็นประโยชน์ให้ผู้วิจัยระบุว่ามีแผนการจะนำประโยชน์ดังกล่าวไปสู่กลุ่มควบคุม/ชุมชนอย่างไร`} autoSize/>
            </Form.Item>
            <p>การจ่ายค่าพาหนะ ค่าชดเชยการเสียเวลา หรือของที่ระลึก</p>
            <Form.Item  style={{marginLeft:'5vw'}} name={'Coverage'}>
                <TextArea placeholder={`        *คำอธิบายวิธีการเขียนชี้แจงอาสาสมัคร : ให้อธิบายว่ามีการจ่ายค่าพาหนะ ค่าชดเชยการเสียเวลา หรือของที่ระลึก ว่ามีหรือไม่มี ให้กำหนดให้ชัดเจน (ส่วนจะเป็นเท่าไรนั้น ให้พิจารณาให้เหมาะสมกับสถานการณ์ ไม่น้อยเกินไปจนเป็นการเอาเปรียบ หรือมากเกินไปจนเป็นการ “ซื้อ” ผู้มีส่วนร่วมในการวิจัย)`} autoSize/>
            </Form.Item>
        </Card>
        <br/>
        <Card>
            <h3>คำชี้แจงเพิ่มเติม</h3>
            <p style={{marginLeft:'5vw'}}>- การเข้าร่วมในการวิจัยของท่านเป็นโดยสมัครใจ และสามารถปฏิเสธที่จะเข้าร่วมหรือถอนตัวจากการวิจัยได้ทุกขณะ โดยไม่ต้องให้เหตุผลและไม่สูญเสียประโยชน์ที่พึงได้รับ และจะไม่มีการเก็บข้อมูลใด ๆ ของท่านเพิ่มเติม หลังจากที่ท่านขอยกเลิกการเข้าร่วมโครงการวิจัยและจะทำลายเอกสารและ/หรือตัวอย่างที่ใช้ตรวจสอบทั้งหมดที่สามารถสืบค้นถึงตัวท่านได้</p>
            <p style={{marginLeft:'5vw'}}>- หากผู้วิจัยมีข้อมูลเพิ่มเติมที่เป็นประโยชน์หรือโทษเกี่ยวกับการวิจัย ผู้วิจัยจะแจ้งให้ท่านทราบอย่างรวดเร็วเพื่อให้ผู้มีส่วนร่วมในการวิจัยทบทวนว่ายังสมัครใจจะอยู่ในงานวิจัยต่อไปหรือไม่ </p>
            <p style={{marginLeft:'5vw'}}>- ข้อมูลที่เกี่ยวข้องกับท่านจะเก็บเป็นความลับ หากมีการเสนอผลการวิจัยจะเสนอเป็นภาพรวม ข้อมูลใดที่สามารถระบุถึงตัวท่านได้จะไม่ปรากฏในรายงาน</p>
            <p style={{marginLeft:'5vw'}}>- หากท่านไม่ได้รับการปฏิบัติเป็นไปตามข้อมูลดังกล่าวสามารถร้องเรียนโดยตรงได้ที่ คณะกรรมการพิจารณาจริยธรรมการวิจัยในมนุษย์ มหาวิทยาลัยวงษ์ชวลิตกุล ที่อยู่ 84 หมู่ 4 ถนนมิตรภาพ ตำบลบ้านเกาะ อำเภอเมือง จังหวัดนครราชสีมา 30000 โทรศัพท์ 044 009711 ต่อ 233</p>

        </Card>
        </Form>
        <br/>
        <Flex justify='space-between'>
            <Button href='/VU_HREC/ProjectInfo'>กลับหน้าแสดงข้อมูล</Button>
            <Button onClick={()=>SaveBack()}>บันทึกและไปต่อ</Button>
        </Flex>
    </>)
}